import React, { useRef, useEffect } from "react";
function InstitutionReportPage() {
  const ref = useRef(null);
  useEffect(
    () =>
      window.DMInstitutionAdminReport
        ? window.DMInstitutionAdminReport.mount(ref.current)
        : undefined,
    [],
  );
  return <div ref={ref} />;
}
export { InstitutionReportPage };
